import React from 'react';
import styled from 'styled-components';
import { useHistory, Link } from 'react-router-dom';

import useAuth from 'Hooks/useAuth';
import * as actions from 'actions';
import { useDispatch } from 'Hooks';
import Config from 'config';
import { useQuery } from '@apollo/client';
import { allContents, allContentsVariables } from '../../../Scenes/SidebarContent/__queries__';
import useI18n from '../../../i18n';
import { GET_SIDEBAR_CONTENT } from '../../../Scenes/SidebarContent';

const SmallMenu = styled.div`
  display: flex;
  flex-flow: column nowrap;
  align-items: flex-start;

  a,
  span {
    font-size: 12px;
    font-weight: normal;
    height: 16px;
    letter-spacing: 0.32px;
    text-decoration: none;
    color: #616164;
    cursor: pointer;
    margin-bottom: 24px;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
  }

  a {
    &:hover {
      @media (min-width: 768px) {
        text-decoration: underline;
      }
    }
  }
`;

interface Props {
  isSignedIn: boolean;
  onCloseMenu: () => void;
}

const SidebarContent: React.FC<Props> = ({ isSignedIn, onCloseMenu }) => {
  const dispatch = useDispatch();
  const { i18n } = useI18n();
  const { logout } = useAuth();
  const { push } = useHistory();

  const { data } = useQuery<allContents, allContentsVariables>(GET_SIDEBAR_CONTENT, {
    variables: {
      companyId: Config.COMPANY_ID,
    },
  });

  const content = data?.allContents || [];

  const handleLogOut = () => {
    // Clear the users availableOffers from state
    dispatch(actions.setAvailableOffers([]));
    logout();
    // We are routing the user back to the landing page when the user logs out.
    // Otherwise, if they log out in the startPage, they are given a corrupt cart.
    push('/');
    onCloseMenu();
  };

  return (
    <SmallMenu>
      {content.map((c) => (
        <Link key={c.id} to={`/sidebar/${c.slug}/`} onClick={onCloseMenu}>
          {i18n(c.title)}
        </Link>
      ))}
      <Link to="/support" onClick={onCloseMenu}>
        {i18n('Navigation.Support')}
      </Link>
      {isSignedIn && <span onClick={handleLogOut}>{i18n('Navigation.Signout')}</span>}
    </SmallMenu>
  );
};

export default SidebarContent;
